<template>
  <div>
    <div class="auth">
      <div class="grayHead">
        <span>
          現在のパスワードと新しいパスワードを入力してください。
        </span>
      </div>
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        name="userLoginForm"
        class="form"
        @submit.prevent="validateBeforeSubmit()"
      >
        <InputText
          v-model="form.login_password"
          :vid="'login_password'"
          :label="'現在のパスワード'"
          :type="'password'"
          :maxlength="20"
          rules="required|min:6|max:20"
          class="form__group"
        />

        <InputText
          v-model="form.new_login_password"
          :vid="'new_login_password'"
          :label="'新しいパスワード'"
          :type="'password'"
          :maxlength="20"
          rules="required|min:6|max:20"
          class="form__group"
        />

        <InputText
          v-model="form.new_login_password_confirmation"
          :vid="'new_login_password_confirmation'"
          :label="'新しいパスワード(確認)'"
          :type="'password'"
          :maxlength="20"
          rules="required|min:6|max:20|confirmed:new_login_password"
          class="form__group"
        />

        <!-- Submit Button -->
        <div class="form__group mt40">
          <Btn
            :label="'送信'"
            :color="'red'"
            :disabled="invalid || isLoading"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import error from '@/mixin/error.mixin'
import store from '@/store'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'

export default {
  name: 'PasswordChangeStep01Form',

  mixins: [
    // APIエラーメッセージ
    error
  ],

  components: {
    InputText,
    Btn
  },

  data () {
    return {
      form: {
        login_password: '',
        new_login_password: '',
        new_login_password_confirmation: ''
      }
    }
  },

  computed: {
    ...mapGetters(['isLoading'])
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        store.commit('loadingAction', true)
        store.dispatch('auth/changePassword', {
          login_password: this.form.login_password,
          new_login_password: this.form.new_login_password,
          new_login_password_confirmation: this.form.new_login_password_confirmation
        }).then((_res) => {
          this.$router.push({
            name: 'AccountEditStep01Form'
          }).catch(() => {})
        }).catch((err) => {
          store.commit('loadingAction', false)
          this.addValidateErrors(this.$refs.observer, err)
        })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/form.pcss';
</style>



// WEBPACK FOOTER //
// src/pages/password-change/Step01Form.vue